import { createSelector } from 'reselect';
import get from 'lodash/get';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
import { getFilters, getRoomTypes } from './propertyAvailabilitySelectors';
import { resolveFirstCancellationWindowWithPenalty } from 'components/CancellationRefundSummary/utils';
import { isBefore } from 'date-fns';

const offerFilterRules = {
  classicRewards: {
    field: 'type',
    matcher: (value) => value === 'classic',
  },
  depositPay: {
    field: 'depositPay.depositPayable',
    matcher: (value) => !!value,
  },
  freeCancellation: {
    field: 'cancellationPolicy',
    matcher: ({ cancellationWindows, isNonrefundable }) => {
      const { startTime } = resolveFirstCancellationWindowWithPenalty(cancellationWindows) || {};
      const isRefundable = !isNonrefundable;
      const hasPenalty = startTime && isBefore(new Date(startTime), new Date());

      return isRefundable && !hasPenalty;
    },
  },
};

export const getAvailableRoomTypesWithFilterData = createSelector(getRoomTypes, getFilters, (roomTypes, filters) => {
  const roomTypesWithOffer = map(roomTypes, (roomType) => {
    const offersWithFilterMetadata = map(roomType.offers, (offer) => {
      const meta = mapValues(filters, (_, key) => {
        const { field, matcher } = offerFilterRules[key] || {};
        const fieldValue = get(offer, field);

        return matcher && matcher(fieldValue);
      });

      return { ...offer, meta };
    });

    return {
      ...roomType,
      offers: offersWithFilterMetadata,
    };
  });

  return roomTypesWithOffer;
});
